import "./LeadGenerationConversionOptimization.module.css";
import Header from "@/reusable_sections/Header";
import Funnel from "./sections/Funnel";
import Conversion from "./sections/Conversion";
import Interactiveleadgenfunnel from "./sections/Interactiveleadgenfunnel";
import Footer from "@/reusable_sections/Footer";
export default function LeadGenerationConversionOptimizationPage() {
  return <div>
      <Header />
      <Funnel />
      <Conversion />
      <Interactiveleadgenfunnel />
      <Footer />
    </div>;
}